import { Box, styled } from "@mui/material";

export const DesktopWrapper = styled(Box)(({ theme }) => ({
  height: "calc(100vh - 64px)",
  display: "flex",
  borderRadius: "8px",
  boxShadow: theme.shadows[3],
  overflow: "hidden",
  backgroundColor: theme.palette.background.paper,
}));
